<particle-input-box-with-tags  class=" full-grow-no-shrink-no-basis "
                              [chatText]="dialogField.value"
                              [DefaultSelectionListDisplayKey]="'text'"
                              [hashTagDisplayKey]="'title'"
                              [FiledLabel]="'Formula Expression'"
                              [hashTagList]="tagOptions"
                              (chatTextChange)="onValueChange($event)"
>
</particle-input-box-with-tags>
